import { useEffect } from "react";
import useDrawerStack from "./useDrawerStack";

export default function useDrawerStackRegister(name, component) {
    const { register } = useDrawerStack();

    useEffect(() => {
        const unregiser = register(name, component);

        return () => {
            unregiser();
        }
    }, []);
}